import DashboardWidget from "../DashboardWidget";
import LibraryAddCheckOutlinedIcon from '@mui/icons-material/LibraryAddCheckOutlined';
import { useEffect, useState } from "react";
import dashboardServicev2 from "../../service/DashboardServicev2";
import { useHistory } from "react-router-dom";

const EBorcWidget = () => {

    const [sayi] = useState(4);
    const [tutar, setTutar] = useState(7802);

    const [loading, setLoading] = useState(false);

    const history = useHistory();


    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                // const _calismaGunu = await dashboardServicev2.getEnSonBorcSorguTarihi();

                // const _date = parse(_calismaGunu, "dd/MM/yyyy HH:mm:ss", new Date());
                // const _formated = format(_date, "yyyy-MM-dd");

                //  console.log('calisma gunu %o', _formated);

                /* const [_sayi, _tutar] = await Promise.all([
                     dashboardServicev2.getEBorcuYokturKayitlari(),
                 ]);*/

                const _tutar = await dashboardServicev2.getEBorcuYokturKayitlari();
                setTutar(_tutar);
                // setCalismaGunu(_formated);

            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        })();
    }, []);

    const onClick = () => {
        history.push(`/eBorc?guncelSorgu=${true}`)
    };


    return (
        <DashboardWidget loading={loading} onClick={onClick}>
            <div style={{ color: "#4D30C2", padding: "0 24px" }}>
                <div style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <LibraryAddCheckOutlinedIcon sx={{ fontSize: 36, color: "#DDD5FF" }} />
                    <span style={{ color: "#987EFF", fontSize: 28 }}>E-Borç</span>
                </div>
                <div style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "12px", lineHeight: "20px", textAlign: "center" }}>
                    {sayi} İşyerinde Toplam
                </div>
                <div style={{
                    background: "#987EFF",
                    borderRadius: "4px",
                    height: "51px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 10,
                    padding: 4
                }}>
                    <div style={{ color: "white", fontSize: "34px", lineHeight: "36px" }}>
                        ₺{new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format(tutar)}
                    </div>
                </div>
            </div>
        </DashboardWidget>
    )

}

export default EBorcWidget;
